import { render, staticRenderFns } from "./AddDataField.vue?vue&type=template&id=0ceaac45&scoped=true"
import script from "./AddDataField.vue?vue&type=script&lang=js"
export * from "./AddDataField.vue?vue&type=script&lang=js"
import style0 from "./AddDataField.vue?vue&type=style&index=0&id=0ceaac45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceaac45",
  null
  
)

export default component.exports